var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "responsiveSection__grid" },
    _vm._l(_vm.marketData.sections, function (section, index) {
      return _c("HighlightSection", {
        key: index,
        attrs: {
          "section-data": section,
          "section-chart-data": section.contents,
          locale: _vm.marketData.locale,
          index: index,
        },
        on: { "set-global-settings": _vm.loadGlobalSettings },
      })
    }),
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }